import React from "react";
import styles from "./CommonLayout.module.css";
import { useLocation, useParams } from "react-router";

const breadcrumb = (paths) => {
  return paths.map((p, i) => {
    if (Number(i) !== 0) {
      return (
        <span key={i} className={styles.otherLinks}>
          {p === "app" ? "home" : p.replace(/-/g, " ")} &nbsp;{" "}
          {!(Number(i) === paths.length - 1) ? "|" : ""}
        </span>
      );
    } else {
      return "";
    }
  });
};

function CommonLayout({ children,NavClass }) {
  const location = useLocation();
  let params= useParams();
  // console.log("params",params);
  
  // console.log("location", location);
  const paths = location.pathname.split("/");
  if (Object.entries(params).length) {
    paths.pop()
  }
  // console.log('paths',paths);
  return (
    <div>
      <div className={styles.breadcrumb}>
        <h1 className={`${styles.firstLink} ${NavClass?NavClass:''} pb-3`}>
          {paths[1] === "app" ? paths[paths.length-1].replace(/-/g, " ") : paths[paths.length-1]}
          {/* {paths[1] === "app" ? paths[2] : paths[1]} */}
        </h1>
        {/* <div className={styles.breadcrumbLink}>
        {breadcrumb(paths)}
        </div> */}
      </div>
      {children}
    </div>
  );
}

export default CommonLayout;
